import { setLoading } from "../../feature/authSlice"
import { apiConstants } from "../apiConstant"
import { serviceCall } from "../serviceCall"

export const getAllRolesApi = (callback, errorCallBack) => {
  return async (dispatch) => {
    dispatch(setLoading(true))
    serviceCall({
      url: apiConstants.AUTH.GET_ALL_ROLES,
      method: 'get',
    })
      .then((response) => {
        dispatch(setLoading(false))
        callback && callback(response)
      })
      .catch((error) => {
        dispatch(setLoading(false))
        errorCallBack && errorCallBack(error.response)
      })
  }
}
